export default {"src":"/_next/static/media/cover-ServicesTOP.ecc42cf3.svg","height":624,"width":1192};